import {Injectable} from '@angular/core';

import {config} from '../smartadmin.config';
import {languages} from './languages.model';
import {JsonApiService} from "../../core/api/json-api.service";
import {Subject} from 'rxjs/Subject';
import {NeoStorageService, NeoGlobalService, Utils} from 'ng-neo';

@Injectable()
export class I18nService {

    public state;
    public data: {};
    public currentLanguage: any;


    constructor(private jsonApiService: JsonApiService,
                private _storage: NeoStorageService,
                private _gs: NeoGlobalService
    ) {
        this.state = new Subject();

        let lang = config.defaultLocale || 'es';

        this.currentLanguage = languages.filter(l => {
            return lang == l.key;
        })[0];

        if (this._storage.getFromLocalStorage('language')) {
            lang = this._storage.getFromLocalStorage('language');
        } else {
            this._storage.setToLocalStorage('language', lang);
        }

        this.initLanguage(lang);
        this.fetch(this.currentLanguage.key)
    }

    public fetch(locale: any) {
        const translations = this._storage.getFromSessionStorage('trans') || [];

        let data = {};

        for (let translation of translations) {
            translation.Translations = translation.Translations || [{Language: locale, Text: ''}];
            data[translation.Label.toLowerCase()] = translation.Translations
                .filter(t => t.Language == locale)[0].Text
        }

        this.setTranslations(data);
    }

    private setTranslations(data) {
        if (Utils.isEmpty(data) || Object.is(this.data, data)) {
            return;
        }

        this.data = data;
        this.state.next(data);
        // this.ref.tick()
    }

    private initLanguage(locale: string) {
        locale = locale || this.currentLanguage.key;

        let language = languages.filter((it) => {
            return it.key == locale
        })[0];

        if (language) {
            this.currentLanguage = language
        } else {
            console.log("No encontrado el idioma {" + locale + "}")
        }
    }

    setLanguage(language) {
        language = language || this.currentLanguage;

        if (typeof language === 'string') {
            language = languages.filter(l => l.key == language)[0];
        }

        this.currentLanguage = language;
        this._storage.setToLocalStorage('language', language.key);
        this._gs.set('lang', language.key);
        this.fetch(language.key);
    }

    subscribe(sub: any, err: any) {
        return this.state.subscribe(sub, err)
    }

    public getTranslation(phrase: string): string {
        this.fetch(this._storage.getFromLocalStorage('language'));
        return this.data && this.data[phrase.toLowerCase()] ? this.data[phrase.toLowerCase()] : phrase
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/i18n/i18n.service.ts